import _ from 'lodash';

export const Images = {
  LOGO: _.get(process.env, 'REACT_APP_LOGO_URL'),
  USER_PLACEHOLDER: require('../assets/images/user.png'),
  CARD_BRANDS: require('../assets/images/Card-Brand-Logos.png'),
};

export default Images;